import React, { FC, memo, useEffect } from 'react';
import { Contract } from 'entities/Contract';
import { useAppTranslation } from 'app/config/i18Config/hooks';
import { Payment } from 'entities/Payment';
import { PaymentCard } from './PaymentCard';
import { Invoice } from 'entities/Invoice';

interface PaymentTabProps {
  payments: Payment[];
  contract: Contract;
  depositInvoice?: Invoice;
}

export const PaymentTab: FC<PaymentTabProps> = memo((props) => {
  const { payments, contract, depositInvoice } = props;

  const { t } = useAppTranslation('contracts');

  return (
    <div>
      {payments.length ? (
        <>
          <div className="font-semibold text-lg pt-7 pb-4">{t('History')}</div>
          <div className="space-y-3">
            {payments.map((payment) => (
              <PaymentCard
                key={payment.paymentId}
                payment={payment}
                deposit={contract.deposit}
                user={contract.user}
                isClosedContract={Boolean(contract.leaveDate)}
                isDepositPayment={depositInvoice?.invoiceId === payment.invoice.invoiceId}
              />
            ))}
          </div>
        </>
      ) : (
        <div className="font-semibold text-lg pt-7 pb-4 text-center">{t('No payments yet')}</div>
      )}
    </div>
  );
});
